import {
  IconUser,
  IconBriefcase,
  IconBulb,
  IconMap2,
  IconPhotoVideo,
} from "@tabler/icons-react";
import styles from '../../../../pages/TalentDashboard/Profile/profile.module.css';

export const TABS = [
  { id: "overview", label: "Overview", icon: IconUser },
  { id: "experience", label: "Experience", icon: IconBriefcase },
  // AI Insights and Media tabs hidden for now — re-enable by uncommenting.
  // { id: "insights", label: "AI Insights", icon: IconBulb },
  { id: "career", label: "Career Plan", icon: IconMap2 },
  // { id: "media", label: "Media", icon: IconPhotoVideo },
];

export default function TabBar({ activeTab, onChange }) {
  return (
    <div className={styles.tabbar}>
      {TABS?.map(({ id, label, icon: Icon }) => {
        const isActive = activeTab === id;
        return (
          <button
            key={id}
            type="button"
            className={`${styles.tab} ${isActive ? styles.tabActive : ""}`}
            onClick={() => onChange(id)}
          >
            <Icon size={16} /> {label}
          </button>
        );
      })}
    </div>
  );
}
